// Copy for the two closing bands of home v2 (join CTA, then newsletter).
// ─── Join band ──────────────────────────────────────────────────────────────
export const JOIN_TITLE = 'Join a growing community of local historians, preservations, and storytellers.';
export const JOIN_LEAD = 'Create an account to start exploring and contributing today.';
export const JOIN_SIGNUP_LABEL = 'Sign Up for Free';
export const JOIN_EXPLORE_LABEL = 'Explore Local History';
export const JOIN_ICON = 'bi-people-fill';
// ─── Newsletter band ────────────────────────────────────────────────────────
export const NEWSLETTER_TITLE = 'Building Stronger Communities Through Local History.';
export const NEWSLETTER_LEAD = 'Get preservation resources, community stories, product updates, and practical tools delivered to your inbox.';
export const NEWSLETTER_FIRST_LABEL = 'First Name';
export const NEWSLETTER_LAST_LABEL = 'Last Name';
export const NEWSLETTER_EMAIL_LABEL = 'Email';
export const NEWSLETTER_SUBMIT_LABEL = 'Subscribe';
export const NEWSLETTER_SUBMITTING_LABEL = 'Subscribing...';
export const NEWSLETTER_SUCCESS = 'Thank you! We will keep you posted.';
export const NEWSLETTER_ERROR = 'Something went wrong. Please try again.';
// Split into three parts so the accent word is a real element rather than
// interpolated markup.
export const NEWSLETTER_CLOSING_BEFORE = 'Together, we can preserve the past and ';
export const NEWSLETTER_CLOSING_ACCENT = 'inspire';
export const NEWSLETTER_CLOSING_AFTER = ' the future.';
// Placeholder: reuses a hero asset, so this image also appears in the hero
// rotation higher up the same page. Swap for a dedicated photo when one exists.
export const NEWSLETTER_IMAGE = {
    src: '/images/landing/hero/district.jpg',
    position: 'center 60%',
};
